import { ReactNode } from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import LayoutContainer from "./LayoutContainer";
import "../../../node_modules/react-grid-layout/css/styles.css";
import "./GridLayout.css";

const ReactGridLayout = WidthProvider(RGL);

interface GridLayoutProps {
  layout: (RGL.Layout & { children?: ReactNode })[];
  onLayoutChange: (layout: RGL.Layout[]) => void;
  removeItem: (id: string) => void;
  editable?: boolean;
  bulkEditMode?: boolean;
  selectedContainerIds?: string[];
  onContainerSelect?: (id: string) => void;
}

const GridLayout = (props: GridLayoutProps) => {
  // Bulk-edit mode disables both drag and resize entirely -- this is what
  // sidesteps the click-vs-drag event-propagation conflict noted in the
  // pitch, rather than trying to make click-to-select coexist with RGL's
  // own drag-start listeners.
  const interactive = props.editable && !props.bulkEditMode;

  return (
    <ReactGridLayout
      layout={props.layout}
      onLayoutChange={props.onLayoutChange}
      cols={96}
      rowHeight={40}
      isResizable={interactive}
      isDraggable={interactive}
    >
      {props.layout.map(({ i, ...restProps }) => {
        return (
          <LayoutContainer
            editable={props.editable}
            removeItem={props.removeItem}
            key={i}
            id={i}
            bulkEditMode={props.bulkEditMode}
            selected={props.selectedContainerIds?.includes(i)}
            onSelectToggle={props.onContainerSelect}
            {...restProps}
          />
        );
      })}
    </ReactGridLayout>
  );
};

export default GridLayout;
